<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M116.07 101.28H78.624C75.874 101.28 73.6448 103.509 73.6448 106.259V113.005C73.6448 115.755 75.874 117.984 78.624 117.984H116.07C118.82 117.984 121.05 115.755 121.05 113.005V106.259C121.05 103.509 118.82 101.28 116.07 101.28Z"
      class="fill-brand-100"
    />
    <path
      d="M113.421 79.104H88.0896C84.76 79.104 82.0608 81.8032 82.0608 85.1328V95.2512C82.0608 98.5808 84.76 101.28 88.0896 101.28H113.421C116.75 101.28 119.45 98.5808 119.45 95.2512V85.1328C119.45 81.8032 116.75 79.104 113.421 79.104Z"
      class="fill-secondary-500"
    />
    <path
      d="M189.126 85.1456H173.178C170.039 85.1456 167.494 87.6901 167.494 90.8288V102.445C167.494 105.584 170.039 108.128 173.178 108.128H189.126C192.265 108.128 194.81 105.584 194.81 102.445V90.8288C194.81 87.6901 192.265 85.1456 189.126 85.1456Z"
      class="fill-brand-100"
    />
    <path
      d="M130.682 156.544C142.484 156.544 152.051 146.977 152.051 135.174C152.051 123.372 142.484 113.805 130.682 113.805C118.88 113.805 109.312 123.372 109.312 135.174C109.312 146.977 118.88 156.544 130.682 156.544Z"
      class="fill-brand-100 stroke-brand-100"
      stroke-width="1.15"
      stroke-miterlimit="10"
    />
    <path
      d="M135.104 113.933C139.522 113.933 143.104 110.351 143.104 105.933C143.104 101.515 139.522 97.9328 135.104 97.9328C130.686 97.9328 127.104 101.515 127.104 105.933C127.104 110.351 130.686 113.933 135.104 113.933Z"
      class="fill-secondary-500"
    />
    <path
      d="M153.984 109.325C161.41 109.325 167.43 103.305 167.43 95.8784C167.43 88.4522 161.41 82.432 153.984 82.432C146.558 82.432 140.538 88.4522 140.538 95.8784C140.538 103.305 146.558 109.325 153.984 109.325Z"
      class="fill-brand-300"
    />
    <path
      d="M192.064 108.269H160.557C155.926 108.269 152.173 112.022 152.173 116.653V148.16C152.173 152.79 155.926 156.544 160.557 156.544H192.064C196.694 156.544 200.448 152.79 200.448 148.16V116.653C200.448 112.022 196.694 108.269 192.064 108.269Z"
      class="fill-secondary-500"
    />
    <path
      d="M103.43 170.349C104.16 169.165 105.03 168.077 105.92 166.976C106.176 165.549 107.174 164.288 108.909 164.083V127.661C108.909 122.31 104.531 117.933 99.1809 117.933C93.8305 117.933 89.4529 122.31 89.4529 127.661V166.56C89.4529 167.174 89.5169 167.776 89.6257 168.365C94.1953 169.197 98.8993 169.446 103.437 170.349H103.43Z"
      class="fill-brand-300"
    />
    <path
      d="M230.611 156.691H216.378V33.4656C216.378 29.5616 212.8 30.592 208.435 30.592C204.07 30.592 200.486 29.8496 200.486 33.7536V156.698H63.2128V33.4656C63.2128 29.5616 59.6352 30.592 55.264 30.592C50.8928 30.592 47.3216 29.8496 47.3216 33.7536V156.698H33.088C29.6704 156.698 26.8992 159.469 26.8992 162.886V169.126C26.8992 172.544 29.6704 175.315 33.088 175.315H35.9616V249.466H227.738V175.315H230.611C234.029 175.315 236.8 172.544 236.8 169.126V162.886C236.8 159.469 234.029 156.698 230.611 156.698V156.691Z"
      class="fill-brand-500"
    />
    <path
      d="M75.7952 128.941H33.0432C25.3978 128.941 19.2 135.139 19.2 142.784C19.2 150.429 25.3978 156.627 33.0432 156.627H75.7952C83.4405 156.627 89.6384 150.429 89.6384 142.784C89.6384 135.139 83.4405 128.941 75.7952 128.941Z"
      class="fill-secondary-500"
    />
    <path
      d="M81.2862 206.938C81.2862 201.586 76.948 197.248 71.5966 197.248C66.2452 197.248 61.907 201.586 61.907 206.938V227.302C61.907 232.654 66.2452 236.992 71.5966 236.992C76.948 236.992 81.2862 232.654 81.2862 227.302V206.938Z"
      class="fill-brand-300"
    />
    <path
      d="M135.097 193.203H92.595C85.3737 193.203 79.5198 199.057 79.5198 206.278C79.5198 213.5 85.3737 219.354 92.595 219.354H135.097C142.319 219.354 148.173 213.5 148.173 206.278C148.173 199.057 142.319 193.203 135.097 193.203Z"
      class="fill-secondary-500"
    />
    <path
      d="M60.1215 211.475H149.465C150.893 211.475 152.051 212.634 152.051 214.061V243.091C152.051 246.611 149.197 249.466 145.677 249.466H63.9103C60.3903 249.466 57.5359 246.611 57.5359 243.091V214.061C57.5359 212.634 58.6943 211.475 60.1215 211.475Z"
      class="fill-brand-100"
    />
    <path
      d="M234.329 34.944C234.323 34.8352 234.31 34.7264 234.297 34.6176C234.297 34.5728 234.291 34.5344 234.285 34.4896C234.253 34.3104 234.227 34.1312 234.182 33.952C234.176 33.9264 234.163 33.9008 234.157 33.8688C234.08 33.5552 233.971 33.248 233.849 32.9408C233.843 32.9216 233.83 32.896 233.817 32.8768C233.792 32.8128 233.76 32.7488 233.734 32.6912L220.217 6.39999H190.797L200.179 33.8688V50.9504C200.179 60.384 207.827 68.032 217.261 68.032C226.694 68.032 234.342 60.384 234.342 50.9504V35.3792C234.342 35.232 234.336 35.0848 234.323 34.9376L234.329 34.944Z"
      class="fill-brand-300"
    />
    <path
      d="M200.185 33.8688L190.797 6.39999H161.376L166.016 33.8688V50.9504C166.016 60.384 173.664 68.032 183.097 68.032C192.531 68.032 200.179 60.384 200.179 50.9504V33.8688H200.185Z"
      class="fill-brand-100"
    />
    <path
      d="M166.016 33.8688L161.376 6.39999H131.955L131.846 33.8688V50.9504C131.846 60.384 139.494 68.032 148.928 68.032C158.361 68.032 166.009 60.384 166.009 50.9504V33.8688H166.016Z"
      class="fill-brand-300"
    />
    <path
      d="M97.779 33.8688L102.617 6.39999H72.883L63.5134 33.8688V50.9504C63.5134 60.384 71.1614 68.032 80.595 68.032C90.0286 68.032 97.6766 60.384 97.6766 50.9504V33.8688H97.7726H97.779Z"
      class="fill-brand-300"
    />
    <path
      d="M29.8045 32.9984C29.8045 32.9984 29.7981 33.0176 29.7917 33.024C29.7917 33.0176 29.7981 33.0048 29.8045 32.9984Z"
      class="fill-brand-100"
    />
    <path
      d="M63.5198 33.8688L73.107 6.39999H43.6862L29.8174 32.9792C29.7022 33.2736 29.6062 33.568 29.5294 33.8688C29.5294 33.8688 29.5102 33.92 29.5038 33.952C29.459 34.1376 29.4334 34.3168 29.4014 34.5024C29.4014 34.5472 29.3886 34.5984 29.3886 34.6432C29.3758 34.752 29.3694 34.8672 29.363 34.976C29.363 35.0016 29.363 35.0272 29.363 35.0528V50.9568C29.363 60.3904 37.011 68.0384 46.4446 68.0384C55.8782 68.0384 63.5262 60.3904 63.5262 50.9568V33.8752L63.5198 33.8688Z"
      class="fill-brand-100"
    />
    <path
      d="M131.872 33.8688L131.974 6.39999H102.554L97.7024 33.8688H97.6768V50.9504C97.6768 60.384 105.325 68.032 114.758 68.032C124.192 68.032 131.84 60.384 131.84 50.9504V33.8688H131.866H131.872Z"
      class="fill-brand-100"
    />
  </svg>
</template>

<script>
  export default {
    name: 'AggregatedOffers'
  }
</script>
